// extracted by mini-css-extract-plugin
export var addressFields = "_p1-0";
export var animationContainer = "_p1-1";
export var footer = "_p1-2";
export var lineItems = "_p1-3";
export var modalContent = "_p1-4";
export var orderName = "_p1-5";
export var strong = "_p1-6";
export var warning = "_p1-7";